module.exports = __webpack_public_path__ + "img/notice.7bbb1ce0.gif";